/*
XOL-552: the telco's "backhaul twin".

A Telco that also carries traffic for itself has a second organisation row in
the Backhaul category with the same name (Maxis Broadband Sdn Bhd 325 -> 806;
"webe digital sdn bhd" 808 matches Webe 326). "+ Backhaul" on a Customer RTB
pre-fills its Provider with that twin.

This lives in the SPA (not behind a new API lookup) because
`getConfig().orgGroups` is already loaded at app start and holds both the Telco
and Backhaul groups, each option `{value: id, label: name, ...}` — SelectOrg
reads the same list.

Babel 6: no optional chaining, no nullish coalescing.
------------------------------------------------------------------------ */

/**
 * The id of the Backhaul-category org whose name matches `telcoName`
 * (trimmed, case-insensitive). Exactly one match, or null: DNB 967
 * ("Digital Nasional Berhad ") has none, and an ambiguous name gets no default.
 */
export function findBackhaulTwinId (orgGroups, telcoName) {
  if (!telcoName || !Array.isArray(orgGroups)) return null

  var want = String(telcoName).trim().toLowerCase()
  var hit = null
  var count = 0

  for (var g = 0; g < orgGroups.length; g++) {
    if (!orgGroups[g] || String(orgGroups[g].label).toLowerCase() !== 'backhaul') continue

    var opts = orgGroups[g].options || []

    for (var i = 0; i < opts.length; i++) {
      if (String(opts[i].label || '').trim().toLowerCase() === want) {
        hit = opts[i].value
        count++
      }
    }
  }

  return count === 1 ? hit : null
}

/**
 * XOL-552 round 3: the same lookup, starting from an org ID.
 *
 * The "New Backhaul Customer" popup only has `sharerId` (the licensee's
 * organisation id), not the org's name, and threading the name down through
 * BackhaulTab -> BackhaulTable -> BackhaulAction is a wider change than a
 * default warrants. `orgGroups` options are `{value: id, label: name}` (API
 * SystemController@getOrgsAsSelect), so: find the option with that id in any
 * non-Backhaul group, then reuse findBackhaulTwinId on its label. An id that
 * exists only in the Backhaul group is not a Telco and has no twin -> null.
 */
export function findBackhaulTwinIdForOrg (orgGroups, orgId) {
  if (orgId === null || orgId === undefined || orgId === '' || !Array.isArray(orgGroups)) return null

  var want = Number(orgId)

  for (var g = 0; g < orgGroups.length; g++) {
    if (!orgGroups[g] || String(orgGroups[g].label).toLowerCase() === 'backhaul') continue

    var opts = orgGroups[g].options || []

    for (var i = 0; i < opts.length; i++) {
      if (Number(opts[i].value) === want) {
        return findBackhaulTwinId(orgGroups, opts[i].label)
      }
    }
  }

  return null
}
